const META_CURRENT_YEAR = /{currentYear}/g;

export function capitalize(string) {
  if (!string || typeof string !== 'string') {
    return null;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function replaceCurrentYear(value) {
  return typeof value === 'string' ? value.replace(META_CURRENT_YEAR, new Date().getFullYear()) : '';
}


/**
 * Дозаполняет числа до двух символов, добавляя в начало ноль
 *
 * @param {number} number
 * @returns {string}
 */
export function prefillZero(number) {
  return (number < 1 || number > 9)
    ? number.toString()
    : '0' + number;
}
